// Lib
import React, { useCallback, useState } from 'react';

// Components
import Spinner from '@components/Spinner';

interface Media {
  type?: string;
  url?: string;
}

interface SpotifyPlayerProps {
  media?: Media;
}

const SpotifyPlayer: React.FC<SpotifyPlayerProps> = ({ media }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const spotifyUrl = useCallback((item?: Media): string | undefined => {
    if (item?.type?.includes('audio') && item?.url?.includes('spotify')) {
      const index = item?.url?.indexOf('spotify.com') ?? -1;
      if (index !== -1 && item.url) {
        return (
          item.url.slice(0, index + 12) + 'embed/' + item.url.slice(index + 12)
        );
      }
      return item?.url;
    }
    return undefined;
  }, []);

  return (
    <div className="relative">
      {!isLoaded && (
        <div className="absolute inset-x-0 bottom-0 top-0 flex items-center justify-center">
          <Spinner />
        </div>
      )}
      <iframe
        title="Spotify player"
        onLoad={() => setIsLoaded(true)}
        src={spotifyUrl(media)}
        height="80"
        frameBorder="0"
        allow="encrypted-media"
        className="w-full"
      />
    </div>
  );
};

export default SpotifyPlayer;
